export const LOCAL_STORAGE_KEY_PREFIX = 'bo_merchant_attachments_last_clicked-'
